import { datadogRum } from '@datadog/browser-rum';
import { captureException } from '@sentry/vue';

const isStaging = document.cookie.match('PodOS-Environment=staging');
const params = new URLSearchParams(window.location.search);

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.eu',
  env: import.meta.env.MODE,
  service: import.meta.env.VITE_APP_NAME,
  version: import.meta.env.VITE_APP_VERSION,
  sessionSampleRate: parseInt(import.meta.env.VITE_DATADOG_SAMPLE_RATE || '0'),
  sessionReplaySampleRate: parseInt(import.meta.env.VITE_DATADOG_REPLY_SAMPLE_RATE || '0'),
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  ...(isStaging
    ? {
        allowedTracingUrls: ['https://api.podos.io', window.location.origin],
        traceSampleRate: 50,
        traceContextInjection: 'sampled',
      }
    : {}),
});


try {
  if (params.has('spotlight')) {
    const id =
      params
        .get('spotlight')
        ?.replace(/[^\w-]/g, '')
        .slice(0, 36) ||
      crypto.randomUUID();

    datadogRum.startSessionReplayRecording({ force: true });
    datadogRum.setGlobalContextProperty('spotlight', {
      id,
    });

    console.log('🔦 Spotlight ID', id);
  }
} catch (error) {
  captureException(error);
}
